<script lang="ts">
  export let nameInlib: any;
  export let size: number;

  import P5 from "p5-svelte";
  import PwtsLib from '@ludans/murano-fantasy';

  let rendering = true;

  const sketch = (p) => {
    p.setup = () => {
      p.createCanvas(size, size);
      p.noLoop();
    };

    p.draw = () => {
      PwtsLib.drawCaneFromLib(p, nameInlib, size);
      rendering = false;
    };
  };
</script>

<span aria-busy={rendering}>
  <P5 {sketch} />
</span>
